import instance from "@/services/api";

export const tierFactTimelineTier2API = {
  async getGprDeviation(sbs_project_id, date_begin, date_end) {
    return await instance()
      .get("/tier/tier_2/gpr_deviation/read/", {
        params: { sbs_project_id, date_begin, date_end },
      })
      .then((res) => res?.data);
  },
  async getLaborSum(sbs_project_id, date_begin, date_end) {
    return await instance()
      .get("/tier/tier_2/labor_sum/read/", {
        params: { sbs_project_id, date_begin, date_end },
      })
      .then((res) => res?.data);
  },
  async getReasons(sbs_project_id, date_begin, date_end) {
    return await instance()
      .get("/tier/tier_2/reasons/read/", {
        params: { sbs_project_id, date_begin, date_end },
      })
      .then((res) => res?.data);
  },
};

export const tierFactTimelineTier3API = {
  async getDeviation(date_begin, date_end) {
    return await instance()
      .get("/tier/tier_3/deviation/read/", {
        params: { date_begin, date_end },
      })
      .then((res) => res?.data);
  },
  async getLaborSum(date_begin, date_end) {
    return await instance()
      .get("/tier/tier_3/labor_sum/read/", {
        params: { date_begin, date_end },
      })
      .then((res) => res?.data);
  },
  async getReasons(date_begin, date_end) {
    return await instance()
      .get("/tier/tier_3/reasons/read/", {
        params: { date_begin, date_end },
      })
      .then((res) => res?.data);
  },
};

export const workTaskFactReasonReportAPI = {
  async getReport(sbs_project_id, block_id, date_begin, date_end) {
    return await instance()
      .get("/tier/work_task_fact_reason_report/read/", {
        params: { sbs_project_id, block_id, date_begin, date_end },
      })
      .then((res) => res?.data);
  },
};


